import React, { useState, useEffect, useContext } from "react";
import { Text, View, TouchableOpacity, StyleSheet, FlatList, useWindowDimensions } from "react-native";

import ProductElement from "../components/ProductElement";
import CartElement from "../components/CartElement";
import { ProductsContext } from "../context/ProductsContext";
import { CartContext } from "../context/CartContext";

import Config from "../config/Config";

const config = new Config();

const WIDTH_TRESHOLD = 640;
const PRODUCT_SPACE = 120;

const ProductsScreen = ({ route, navigation }) => {
  const { width, height } = useWindowDimensions();
  const [productsTitle, setProductsTitle] = useState("");
  const { products, getCategoryProducts, popProducts } = useContext(ProductsContext);
  const { cart, emptyCart } = useContext(CartContext);

  /*
  const processBackButton = () => {
    listener.remove();
    // Navigation will be defined by the provider, thus passing callback
    popProducts(() => {
      navigation.navigate("Categories");
    });
  }
  */
  const { navigationAction, order } = route.params;

  useEffect(() => {
    const { title, id } = route.params;
    setProductsTitle(title),
    getCategoryProducts(id);
  }, []);

  // Portrait proportion (section1/section2): 9/5 (14)
  // Landscape proportion (section1/section2): 4/3 (7)
  const portrait = (width < WIDTH_TRESHOLD);
  const section1Height = Math.trunc(portrait ? height * 9/14 : height);
  const section2Height = portrait ? height - section1Height : height - 60;

  return (
    <View style={portrait ? styles.verticalLayout : styles.horizontalLayout}>
      <View style={{flex: portrait ? 9 : 4}}>
        <Text style={styles.productsTitle}>{productsTitle}</Text>
        <FlatList 
          LisHeaderComponent={<Text></Text>}
          ListFooterComponent={<Text></Text>}
          contentContainerStyle={styles.listStyle}
          numColumns={Math.trunc(portrait ? width / PRODUCT_SPACE : width * 4/7 / PRODUCT_SPACE)}
          data={products}
          keyExtractor={product => product.sku}
          renderItem={({ item }) => {
            return ( 
                <View style={styles.productItem}>
                  <ProductElement item={item} setProductsTitle={setProductsTitle} />
                </View>
            );
          }}
        />
      </View>
      <View style={{ flex: portrait ? 5 : 3, justifyContent: 'flex-start', backgroundColor: config.SECTION2_COLOR }}>
      <CartElement action={'create'} maxHeight={section2Height - 90} hideTitle={portrait}/>
        {!emptyCart() &&
          <View style={{flexDirection: 'row', justifyContent: 'space-around'}}>
            <TouchableOpacity style={styles.buttons} onPress={() => navigation.navigate("Categories", "GO_BACK")}>
              <Text style={styles.buttonText}>Mais itens</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={() => {
              if (navigationAction === 'EDIT_ORDER') {
                navigation.navigate("OrderDetails", { selectedOrder: order, navigationAction: navigationAction });
              } else {
                navigation.navigate("Checkout", { cart: cart })
              }
            }}>
              <Text style={styles.buttonText}>Finalizar</Text>
            </TouchableOpacity>
          </View>
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  verticalLayout: {
    flexDirection: "column",
    flex: 1
  },
  horizontalLayout: {
    flexDirection: "row",
    justifyContent: 'center',
    flex: 1
  },
  listStyle: {
    margin: 5
  },
  productItem: {
    marginBottom: 15
  },
  buttons: {
    backgroundColor: '#965E11',
    width: 120,
    marginTop: 10,
    paddingVertical: 10,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
    fontSize: 17,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: 'white'
  },
  productsTitle: {
    fontSize: 30,
    fontWeight: 'bold',
    margin: 10
  }
});

export default ProductsScreen;